// extracted by mini-css-extract-plugin
export default {"contentRoot":"contentRoot__NdPiM"};